import {
  _apiHeaderConfigs,
  getCurrentRegionAPIConfigs,
  makeRequest,
} from '../../../components/utils/APIsUtils/httpsUtils';
import {parseJwt} from '../../../components/utils/commonUtil';
import config from '../../../config';
import SegmentsService from '../../../service/SegmentsService';
import {
  SET_AFFILIATE_CODE,
  SET_SELECTED_AFF_CODE,
  setAffiliateCode,
  setSelectedAffiliateCode,
} from '../roaster/roasterListingActions';
import {
  setCurrentUserId,
  setIsUserLoggedIn,
  setNotificationData,
  setRemoteConfig,
} from '../uiActions';

export const SET_SEGMENT_LOADER = 'SET_SEGMENT_LOADER';
export const SET_SEGMENTS_LIST = 'SET_SEGMENTS_LIST';
export const SET_SELECTED_SEGMENT = 'SET_SELECTED_SEGMENT';
export const SET_IS_SEGMENT_ASSIGNED = 'SET_IS_SEGMENT_ASSIGNED';

const currentRegionAPIConfigs = getCurrentRegionAPIConfigs();

export const setSegmentLoader = (options) => {
  return {
    type: SET_SEGMENT_LOADER,
    payload: options,
  };
};

export const setSegmentList = (options) => {
  return {
    type: SET_SEGMENTS_LIST,
    payload: options,
  };
};

export const setSelectedSegment = (options) => {
  return {
    type: SET_SELECTED_SEGMENT,
    payload: options,
  };
};

export const setIsSegmentAssigned = (options) => {
  return {
    type: SET_IS_SEGMENT_ASSIGNED,
    payload: options,
  };
};

export const fetchSegmentList = (segmentId) => {
  return async (dispatch) => {
    try {
      dispatch(setSegmentLoader(true));
      const response = await SegmentsService.getSegmentList();
      const segmentsList = response?.data;
      dispatch(setSegmentList(segmentsList));

      if (segmentId) {
        const assignedSegment = segmentsList.find((s) => s?.segmentId === segmentId);
        dispatch(setSelectedSegment(assignedSegment));

        const sales_plan_aff = assignedSegment?.sales_plan_aff
          ?.split(',')
          .map((code) => ({salesPlanAffCode: code, id: code, name: code}));

        dispatch({
          type: SET_AFFILIATE_CODE,
          payload: sales_plan_aff,
        });

        dispatch({
          type: SET_SELECTED_AFF_CODE,
          payload: sales_plan_aff?.length ? sales_plan_aff[0] : {},
        });
      }
    } catch (error) {
      console.log('error', error);
      dispatch(setSegmentList([]));
    } finally {
      dispatch(setSegmentLoader(false));
    }
  };
};

export const assignSegmentId = ({countries, history, oktaUserInfo, countryLabel = '', sales_plan_aff = '', isSegmentAssigned = false}) => {
  return async (dispatch) => {
    try {
      console.log('DEBUG : ', {countries, history, oktaUserInfo, countryLabel});
      dispatch(setSegmentLoader(true));
      // const entraToken = JSON.parse(localStorage.getItem('entra-token-storage'));
      
      const {_accessToken, _idToken, idTokenData} = await _apiHeaderConfigs()

      if (_accessToken) {
        const userInfo = idTokenData;

        const { family_name = "", given_name = "", name = "" } = idTokenData

        const nativeid = userInfo?.nativeid?.toLowerCase()

        const response = await SegmentsService.assignSegmentId(nativeid, countries);

        const apiUrl = currentRegionAPIConfigs.baseURL + '/api/v1/users?isAdmin=true';
        await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            authorization: _accessToken,
            profile: _idToken,
          },
          body: JSON.stringify({
            firstName: given_name,
            lastName: family_name,
            name: name,
            partyId: nativeid,
          }),
        })
          .then((response) => response.json())
          .then(async (data) => {
            console.log("auto assign dispatch")
            console.log("config", config)
            console.log("data", data)
            if (config?.is_segmented && data?.data?.segmentId) {
              dispatch(setIsUserLoggedIn(true));
              dispatch(setIsSegmentAssigned(true));
              // history.push('/dashboard');
            }

            makeRequest({
              method: 'GET',
              endpoint: `/api/v2/remote-config`,
            })
              .then((apiData) => {
                if (apiData?.data) {
                  dispatch(setRemoteConfig(apiData?.data));

                  // const sales_plan_aff = apiData?.data?.sales_plan_aff
                  //   ?.split(',')
                  //   .map((code) => ({salesPlanAffCode: code, id: code, name: code}));
                  const selectedAffCodeObj = {salesPlanAffCode: sales_plan_aff, id: sales_plan_aff, name: sales_plan_aff};
                  

                  dispatch(setAffiliateCode([selectedAffCodeObj]));
                  dispatch(
                    setSelectedAffiliateCode(sales_plan_aff?.length ? selectedAffCodeObj : {}),
                  );
                }

                if (data && data.data) {
                  const {amwayId} = data.data;
                  if (amwayId) {
                    dispatch(setCurrentUserId(amwayId));
                    window.localStorage.setItem('am_id', amwayId);
                  }
                } else {
                  console.log('DEBUG Login /login');

                  localStorage.clear();
                  history.push('/login');
                }
              })
              .catch((err) => {
                dispatch(setIsSegmentAssigned(false));
                dispatch(
                  setNotificationData({
                    show: true,
                    type: 'WARNING',
                    title: 'Failed to fetch remote config',
                    description: ``,  
                  }),
                );

                localStorage.clear();
                history.push('/login');
              });
          });
      }

      // Only show login notification on NEW assignments, not on auto-assignment during page reloads
      if (!isSegmentAssigned) {
        dispatch(
          setNotificationData({
            show: true,
            type: 'SUCCESS',
            title: countryLabel ? `You are logged in to ${countryLabel}` : '',
            description: ``,
          }),
        );
      }
    } catch (error) {
      console.log('error', error);
      dispatch(setIsSegmentAssigned(false));
      dispatch(
        setNotificationData({
          show: true,
          type: 'WARNING',
          title: 'Failed to assign segment ID to the Admin',
          description: ``,
        }),
      );

      localStorage.clear();
      history.push('/login');
    } finally {
      dispatch(setSegmentLoader(false));
    }
  };
};

export const autoAssignSegment = ({oktaUserInfo, history}) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setSegmentLoader(true));
      const response = await SegmentsService.getSegmentList();
      const segmentsList = response?.data;
      dispatch(setSegmentList(segmentsList));

      console.log('segmentsList: ', { segmentsList, config})

      const segmentDetails = segmentsList.find((s) => s?.countries === config?.currentName);

      if (segmentDetails) {
        dispatch(setSelectedSegment(segmentDetails));

        const sales_plan_aff = segmentDetails?.sales_plan_aff
          ?.split(',')
          .map((code) => ({salesPlanAffCode: code, id: code, name: code}));


        // dispatch({
        //   type: SET_AFFILIATE_CODE,
        //   payload: sales_plan_aff,
        // });

        dispatch({
          type: SET_SELECTED_AFF_CODE,
          payload: sales_plan_aff?.length ? sales_plan_aff[0] : {},
        });

        dispatch(setAffiliateCode(sales_plan_aff));

        // Check if segment is already assigned (page reload)
        const state = getState();
        const isSegmentAlreadyAssigned = state?.segment?.isSegmentAssigned;

          dispatch(
            assignSegmentId({
              countries: segmentDetails?.countries,
              history,
              oktaUserInfo,
              countryLabel: segmentDetails?.label,
              sales_plan_aff: sales_plan_aff[0]?.salesPlanAffCode,
              isSegmentAssigned: isSegmentAlreadyAssigned // Show notification only on first assignment, not on page reloads
            }),
          );

      } else {
        dispatch(setIsSegmentAssigned(false));
        dispatch(
          setNotificationData({
            show: true,
            type: 'WARNING',
            title: 'Failed to auto assign the segment ID to the Admin',
            description: `Segment details not found`,
          }),
        );

        localStorage.clear();
        history.push('/login');
      }
    } catch (error) {
      console.log('error', error);
      dispatch(setSegmentList([]));
    } finally {
      dispatch(setSegmentLoader(false));
    }
  };
};
